/** Distributes items into columns in row-major order (0, 1, 2, 0, 1, 2, …). */
export const distributeIntoColumns = <T>(
    items: T[],
    columnCount: number,
): T[][] => {
    const columns = Array.from({ length: columnCount }, () => [] as T[]);

    items.forEach((item, index) => {
        columns[index % columnCount].push(item);
    });

    return columns;
};
